import React from 'react'
import { Box, Button, FormControl, Grid, MenuItem, TextField } from '@mui/material'

import { CashSection } from './CashSection';
import { DepositSection } from './DepositSection';
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather';

export const LegalizationPayment = ({ useFetchInit }) => {

    const { 
        //------------- Generales
        // location,
        // paramsURL,
        //------------- globalStates
        globalStates,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions,
        //------------- helpers
        // Helpers,
        //------------- Formularios
        Forms
        
    } = useFetchInit

    // ------------------------------------------------ Generales
        
    // ------------------------------------------------ globalStates
    const {formOpeningMode} = globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormLegalizationPayment, FormRequestGlobal } = Forms
    const { formState, onInputChange } = FormLegalizationPayment
    
    // ------------------------------------------------ FetchData
    
    // ------------------------------------------------ Actions
    const {
        handleChangeTypeTransaction,
        handleChangeAmount,
        handleChangeTypeCurrency,
        handleChangeExchangeRate,
        closeModal,
        onsubmitLegalizationPayment
    } = Actions

    
    const isLegalizationPaymentRequired = ((parseFloat(FormRequestGlobal.formState.legalizacion_exoneracion) >= 0) && (parseFloat(FormRequestGlobal.formState.legalizacion_exoneracion) < parseFloat(FormRequestGlobal.formState.legalizacion_monto)))
    // const isLegalizationPaymentRequired = 1

    return (
        <>
            {/* Si se exonera el pago de la legalización, este paso no es necesario */}
            {(isLegalizationPaymentRequired) && (
                <>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                            <FormControl fullWidth>
                                <label htmlFor="movimiento_fecha">* Fecha</label>
                                <TextField
                                    id="movimiento_fecha"
                                    name="movimiento_fecha"
                                    value={formState.movimiento_fecha}
                                    onChange={onInputChange}
                                    // label='Fecha'
                                    size='small'
                                    type="date"
                                    variant={(formState.idmovimiento > 0 || formState.movimiento_tipo === 'EFECTIVO' || formOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                    hiddenLabel
                                    InputProps={{
                                        readOnly: (formState.idmovimiento > 0 || formState.movimiento_tipo === 'EFECTIVO' || formOpeningMode === 'READONLY') ? true : false 
                                    }}
                                    required
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                            <FormControl fullWidth>
                                <label htmlFor="movimiento_tipo">* Tipo</label>
                                <TextField
                                    id="movimiento_tipo"
                                    name="movimiento_tipo"
                                    // label="Tipo de movimiento"
                                    value={formState.movimiento_tipo}
                                    onChange={handleChangeTypeTransaction}
                                    select
                                    size="small"
                                    variant={(formState.idmovimiento > 0 || formOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                    // lable="Selecciona una opción"
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: (formState.idmovimiento > 0 || formOpeningMode === 'READONLY') ? true : false 
                                    }}
                                >
                                    <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                                    <MenuItem value='DEPOSITO'>DEPOSITO</MenuItem>
                                    <MenuItem value='EFECTIVO'>EFECTIVO</MenuItem>
                                </TextField>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="pt-2"></div>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={6} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                            <FormControl fullWidth>
                                <label htmlFor="movimiento_monto">* Monto</label>
                                <TextField
                                    id="movimiento_monto"
                                    name="movimiento_monto"
                                    value={formState.movimiento_monto}
                                    onChange={handleChangeAmount}
                                    // label='Monto a recibir'
                                    size='small'
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    variant={(formState.idmovimiento > 0 || formOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: (formState.idmovimiento > 0 || formOpeningMode === 'READONLY') ? true : false 
                                    }}
                                    required
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                            <FormControl fullWidth>
                                <label htmlFor="movimiento_moneda">* Moneda</label>
                                <TextField
                                    id="movimiento_moneda"
                                    name="movimiento_moneda"
                                    // label="Moneda"
                                    value={formState.movimiento_moneda}
                                    onChange={handleChangeTypeCurrency}
                                    select
                                    size="small"
                                    variant={(formState.idmovimiento > 0 || formOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                    // lable="Selecciona una opción"
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: (formState.idmovimiento > 0 || formOpeningMode === 'READONLY') ? true : false 
                                    }}
                                >
                                    <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                                    <MenuItem value='QUETZAL'>QUETZAL</MenuItem>
                                    <MenuItem value='DOLAR'>DOLAR</MenuItem>
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                            <FormControl fullWidth>
                                <label htmlFor="movimiento_tipo_cambio">* Tipo de Cambio</label>
                                <TextField
                                    id="movimiento_tipo_cambio"
                                    name="movimiento_tipo_cambio"
                                    value={formState.movimiento_tipo_cambio}
                                    onChange={handleChangeExchangeRate}
                                    // label='Tipo de cambio'
                                    size='small'
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    variant={(formState.idmovimiento > 0 || formOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: (formState.idmovimiento > 0 || formOpeningMode === 'READONLY') ? true : false 
                                    }}
                                    required
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="pt-2"></div>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                            <FormControl fullWidth>
                                <label htmlFor="movimiento_quetzales">* Total en Quetzales</label>
                                <TextField
                                    id="movimiento_quetzales"
                                    name="movimiento_quetzales"
                                    value={formState.movimiento_quetzales}
                                    onChange={onInputChange}
                                    // label='Total en quetzales'
                                    size='small'
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: (formState.idmovimiento > 0 || formOpeningMode === 'READONLY') ? true : false 
                                    }}
                                    required
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                            <FormControl fullWidth>
                                <label htmlFor="movimiento_dolares">* Total en Dolares</label>
                                <TextField
                                    id="movimiento_dolares"
                                    name="movimiento_dolares"
                                    value={formState.movimiento_dolares}
                                    onChange={onInputChange}
                                    // label='Total en dolares'
                                    size='small'
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    variant='filled'
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: (formState.idmovimiento > 0 || formOpeningMode === 'READONLY') ? true : false 
                                    }}
                                    required
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="pt-2"></div>
                    {(formState.movimiento_tipo === 'EFECTIVO') && (
                        <>
                            <CashSection useFetchInit={useFetchInit}/>
                        </>
                    )}
                    {(formState.movimiento_tipo === 'DEPOSITO') && (
                        <>
                            <DepositSection useFetchInit={useFetchInit}/>
                        </>
                    )}
                    <div className="pt-2"></div>
                    <div className="pt-4"></div>
                    <Box className="text-center" sx={{mt: 2}}>
                        <Button 
                            startIcon={<ArrowLeftCircle/>}
                            variant="contained"
                            type="button" 
                            className='btn-round'
                            color='warning'
                            onClick={closeModal} 
                            sx={{ marginRight: 1, marginLeft: 1 }}
                        >
                            Volver
                        </Button>
                        {/* <Button
                            endIcon={<ArrowRightCircle/>}
                            variant="contained"
                            className='btn-round'
                            color='primary'
                            type='button'
                            onClick={onsubmitLegalizationPayment}
                            sx={{ marginRight: 1, marginLeft: 1 }}
                        >
                            Continuar
                        </Button> */}

                        {(formOpeningMode==='EDITABLE') && (
                            <Button
                                endIcon={<ArrowRightCircle/>}
                                variant="contained"
                                className='btn-round'
                                color='primary'
                                type='button'
                                onClick={onsubmitLegalizationPayment}
                                sx={{ marginRight: 1, marginLeft: 1 }}
                            >
                                Continuar
                            </Button>
                        )}
                    </Box>
                </>
            )}
            
        </>
    )
}
